import { itemByLocales, realEstateFiltersDict } from '@monoimin/intl';

import { FilterConfigs } from '../types';
import {
  EMPTY_FILTER_ITEMS,
  ESTATE_FILTER_KEYS,
  MAX_PRICE,
  MIN_PRICE,
  BEDROOMS,
  BATHROOMS,
  FILTER_VARIANTS,
} from '../constants';

export const managersFilterConfigs: FilterConfigs = [
  {
    filterKey: ESTATE_FILTER_KEYS.COUNTRY,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'termOptionAll',
    searchPlaceholderDictionaryKey: 'findCountry',
    filterItems: EMPTY_FILTER_ITEMS,
    withSearch: true,
    variant: 'column',
    options: [
      {
        title: {
          en: 'Option250',
          ru: 'Option250',
        },
        filterConfigs: [
          {
            filterKey: ESTATE_FILTER_KEYS.COST_FOR_GR,
            value: 'option 250',
            filterVariant: FILTER_VARIANTS.OPTION,
          },
        ],
        dependencies: [
          { filterKey: ESTATE_FILTER_KEYS.COUNTRY, value: 'greece' },
        ],
      },
      {
        title: {
          en: 'Option400',
          ru: 'Option400',
        },
        filterConfigs: [
          {
            filterKey: ESTATE_FILTER_KEYS.COST_FOR_GR,
            value: 'option 400',
            filterVariant: FILTER_VARIANTS.OPTION,
          },
        ],
        dependencies: [
          { filterKey: ESTATE_FILTER_KEYS.COUNTRY, value: 'greece' },
        ],
      },
      {
        title: {
          en: 'Option800',
          ru: 'Option800',
        },
        filterConfigs: [
          {
            filterKey: ESTATE_FILTER_KEYS.COST_FOR_GR,
            value: 'option 800',
            filterVariant: FILTER_VARIANTS.OPTION,
          },
        ],
        dependencies: [
          { filterKey: ESTATE_FILTER_KEYS.COUNTRY, value: 'greece' },
        ],
      },
    ],
  },
  {
    filterKey: ESTATE_FILTER_KEYS.CITY,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'allCities',
    searchPlaceholderDictionaryKey: 'findCity',
    filterItems: EMPTY_FILTER_ITEMS,
    withSearch: true,
    variant: 'column',
  },
  {
    filterKey: {
      from: ESTATE_FILTER_KEYS.PRICE_FROM,
      to: ESTATE_FILTER_KEYS.PRICE_TO,
    },
    filterVariant: FILTER_VARIANTS.RANGE,
    placeholderDictionaryKey: 'anyPrice',
    fromPlaceholderDictionaryKey: 'priceFrom',
    toPlaceholderDictionaryKey: 'priceTo',
    min: MIN_PRICE,
    max: MAX_PRICE,
    step: 10,
    variant: 'plain',
    options: [
      {
        title: {
          en: 'Profitable',
          ru: 'Выгодно',
        },
        filterConfigs: [
          {
            filterKey: ESTATE_FILTER_KEYS.BEST_OFFER,
            value: 'true',
            filterVariant: FILTER_VARIANTS.OPTION,
          },
        ],
      },
      {
        title: {
          en: 'Not in the program',
          ru: 'Не в программе',
        },
        filterConfigs: [
          {
            filterKey: ESTATE_FILTER_KEYS.ELIGIBLE_FOR_PROGRAM,
            value: 'false',
            filterVariant: FILTER_VARIANTS.OPTION,
          },
        ],
      },
    ],
    className: 'lg:col-span-2',
    hideSlider: true,
    hideInput: false,
  },
  {
    filterKey: ESTATE_FILTER_KEYS.OBJECT_TYPE,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'objectType',
    filterItems: realEstateFiltersDict.objectTypes,
    variant: 'column',
  },
  {
    filterKey: ESTATE_FILTER_KEYS.DEVELOPER,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'developer',
    filterItems: EMPTY_FILTER_ITEMS,
    withSearch: true,
    variant: 'column',
  },
  {
    filterKey: ESTATE_FILTER_KEYS.ESTATE_TYPE,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'typeOfProperty',
    filterItems: realEstateFiltersDict.estateTypes,
    variant: 'column',
  },
  {
    filterKey: ESTATE_FILTER_KEYS.OBJECT_STAGE,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'objectStage',
    filterItems: realEstateFiltersDict.objectStages,
    variant: 'column',
  },
  {
    filterKey: ESTATE_FILTER_KEYS.BEDROOMS,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'bedrooms',
    filterItems: itemByLocales(BEDROOMS),
    variant: 'row',
  },
  {
    filterKey: ESTATE_FILTER_KEYS.RENTAL_YIELD_FROM,
    filterVariant: FILTER_VARIANTS.INPUT,
    placeholderDictionaryKey: 'rentalYield',
    className: 'lg:col-span-1',
    variant: 'number',
  },
  {
    filterKey: ESTATE_FILTER_KEYS.OBJECT_CATEGORY,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'objectCategory',
    filterItems: realEstateFiltersDict.objectCategories,
    variant: 'column',
    hideUnderSpoiler: true,
  },
  {
    filterKey: ESTATE_FILTER_KEYS.DESIGN_FEATURE,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'designFeature',
    filterItems: realEstateFiltersDict.registrationFeatures,
    variant: 'column',
    hideUnderSpoiler: true,
  },
  {
    filterKey: ESTATE_FILTER_KEYS.SEARCH,
    filterVariant: FILTER_VARIANTS.INPUT,
    variant: 'text',
    placeholderDictionaryKey: 'findingValues',
    icon: 'search',
    className: 'lg:col-span-3',
    hideUnderSpoiler: true,
  },
  {
    filterKey: ESTATE_FILTER_KEYS.VIEW,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'view',
    filterItems: realEstateFiltersDict.views,
    variant: 'column',
    hideUnderSpoiler: true,
  },
  {
    filterKey: ESTATE_FILTER_KEYS.IS_ISLAND,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'mainlandOrIsland',
    filterItems: realEstateFiltersDict.island,
    variant: 'column',
    hideUnderSpoiler: true,
  },
  {
    filterKey: {
      from: ESTATE_FILTER_KEYS.OCEAN_FROM,
      to: ESTATE_FILTER_KEYS.OCEAN_TO,
    },
    filterVariant: FILTER_VARIANTS.RANGE,
    placeholderDictionaryKey: 'distanceToOceanFull',
    fromPlaceholderDictionaryKey: 'toWaterFrom',
    toPlaceholderDictionaryKey: 'toWaterTo',
    min: 0,
    max: 0,
    step: 10,
    className: 'lg:col-span-2',
    hideSlider: true,
    hideInput: false,
    hideUnderSpoiler: true,
    variant: 'plain',
  },
  {
    filterKey: ESTATE_FILTER_KEYS.BATHROOMS,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'bathrooms',
    filterItems: itemByLocales(BATHROOMS),
    variant: 'row',
    hideUnderSpoiler: true,
  },
  {
    filterKey: ESTATE_FILTER_KEYS.FURNITURE,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'furniture',
    filterItems: realEstateFiltersDict.furnitures,
    variant: 'column',
    hideUnderSpoiler: true,
  },
  {
    filterKey: ESTATE_FILTER_KEYS.PARKING,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'parking',
    filterItems: realEstateFiltersDict.selectTrueFalse,
    variant: 'column',
    hideUnderSpoiler: true,
  },
];
